export default __webpack_public_path__ + "static/media/phone.afb1fea2.svg";